import type { SqliteAsyncConnection } from '../../shared/localDb';

/**
 * ADR-017: no hay SQLite de ventas. El payment_status vive en servidor.
 *
 * // TECH DEBT (temporary adapter): Customers aún llama esto tras writes locales
 * legacy. No inventar `'paid'` — eso ocultaba deuda (legacy-noop-prevention).
 * Invalidá caches remotas en el caller (`invalidateSaleDetailCache`).
 */
export async function recalculateSalePaymentStatus(
  _saleId: string,
  _connection?: SqliteAsyncConnection
): Promise<void> {
  // intentional no-op — server is source of truth
}
